const md5 = require('js-md5')

function BoqiiAuth() {
    this.token = 'dentist2019'
}

BoqiiAuth.prototype.signParams = function (params) {
    var token = this.token

    var newParamsWithOrder = this.sortByAscendingKeys(params)

    var stringToSign = this.joinValues(newParamsWithOrder) + token

    return md5(stringToSign)
}


BoqiiAuth.prototype.sortByAscendingKeys = function (obj) {
    var newObj = {}

    var keys = obj && Object.keys(obj)
    keys = (keys || []).sort(function (a, b) {
        if (a > b) return 1
        if (a == b) return 0
        return -1
    })
    for (var i in keys) {
        newObj[keys[i]] = obj[keys[i]]
    }
    return newObj
}

BoqiiAuth.prototype.joinValues = function (obj) {
    var keys = Object.keys(obj)
    var values = []
    for (var i in keys) {
        values.push(obj[keys[i]])
    }
    return values.join('')
}

export default BoqiiAuth